<template>
  <app-popup :active.sync="isActive" title="Создание приборов тепла"
             class="house-importer-import-create-heater-devices-popup">
    <div class="house-importer-import-create-heater-devices-popup__switch house-importer-import-create-heater-devices-popup__row">
      <label class="house-importer-import-create-heater-devices-popup__switch-label" @click="by_charge = false">На
        основе расхода</label>
      <app-switch v-model="by_charge" size="small"
                  class="house-importer-import-create-heater-devices-popup__switch-switch"/>
      <label class="house-importer-import-create-heater-devices-popup__switch-label" @click="by_charge = true">На основе
        начислений</label>
    </div>

    <template v-if="by_charge">
      <div class="house-importer-import-create-heater-devices-popup__row">
        <app-input label="Название тарифа в Квартале" v-model="tarif_name" :danger.sync="tariffErrors.name"
                   danger-text="Заполните имя тарифа"/>
      </div>
      <div class="house-importer-import-create-heater-devices-popup__row">
        <app-input label="Значение тарифа в Квартале" v-model="tarif_value" vtype="udouble"
                   :danger.sync="tariffErrors.value" danger-text="Заполните значение тарифа"/>
      </div>
    </template>

    <div style="text-align: center">
      <app-button color="success" :disabled="isCreating" @click="askUserForCreateDevices">{{isCreating ? 'Создаю' : 'Создать'}}
      </app-button>
    </div>
  </app-popup>
</template>

<script>
  export default {
    name: "CreateHeaterDevicesPopup",
    props: {
      importInfo: {}
    },
    data() {
      return {
        isCreating: false,
        isActive: false,
        by_charge: false,
        tarif_name: null,
        tarif_value: null,
        tariffErrors: {
          name: false,
          value: false,
        }
      }
    },
    methods: {
      checkForErrors() {
        if (this.tarif_name === null || !this.tarif_name.length) {
          this.tariffErrors.name = true;
        }
        if (this.tarif_value === null || !this.tarif_value.length) {
          this.tariffErrors.value = true;
        }
        return this.tariffErrors.name || this.tariffErrors.value;
      },
      resetErrors() {
        this.tariffErrors.name = false;
        this.tariffErrors.value = false;
      },
      open() {
        this.isActive = true;
      },
      askUserForCreateDevices() {
        if (this.by_charge && this.checkForErrors()) {
          return false;
        }

        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Подтверждение',
          text: 'Уверены что нужно создать приборы?',
          acceptText: 'Да',
          cancelText: 'Нет',
          accept: this.createDevices
        });
      },
      async createDevices() {
        this.isCreating = true;
        try {
          this.resetErrors();
          let body = {
            import_id: this.importInfo.id
          };
          if (this.by_charge) {
            if (this.checkForErrors()) {
              return false;
            } else {
              body.by_charge = this.by_charge;
              body.tarif_name = this.tarif_name;
              body.tarif_value = Number(this.tarif_value);
            }
          }
          let {data} = await this.$http.post('import/houses/empty_heat_devices', body);

          if (data === 'created') {
            this.$vs.notify({color: 'success', title: 'Приборы созданы'});
            this.isActive = false;
            this.$emit('created');
          } else {
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        } finally {
          setTimeout(() => {
            this.isCreating = false
          }, 300);
        }
      },
    }
  }
</script>

<style lang="scss">
  .house-importer-import-create-heater-devices-popup {
    &__switch {
      display: flex;
      align-items: center;

      &-label {
        line-height: 1.1;
        cursor: pointer;
        color: #627084;
        display: block;
        flex: 1;
        white-space: nowrap;
      }

      &-switch {
        flex-shrink: 0;
        margin: 0 10px;
      }
    }

    &__row {
      margin-bottom: 15px;
    }
  }

  .con-vs-dialog{
    z-index: 999999;
  }
</style>
